import { all } from 'redux-saga/effects';

import { authSaga } from './auth/sagas';
import { profileSaga } from './profile/sagas';
import { postsSaga } from './posts/sagas';
import { attachSaga } from './attach/sagas';
import { feedSaga } from './feed/sagas';
import { searchSaga } from './search/sagas';
import { followersSaga } from './followers/sagas';
import { groupsSaga } from './groups/sagas';
import { imSaga } from '$store/im/sagas';
import { realtimeSaga } from '$store/realtime/sagas';
import { blacklistSaga } from '$store/blacklist/sagas';
import { notifySaga } from '$store/notify/sagas';
import { inviteSaga } from '$store/invite/sagas';
import { editGroupSaga } from '$store/editGroup/sagas';
import { resolverSaga } from '$store/resolver/sagas';
import { mainSaga } from '$store/main/sagas';
import { likesSaga } from '$store/likes/sagas';
import { balanceSaga } from '$store/balance/sagas';
import { agentSaga } from '$store/agent/sagas';
import { monetizationSaga } from '$store/monetization/sagas';
import { exploreSaga } from '$store/explore/sagas';
import { subscriptionsSaga } from '$store/subscriptions/sagas';
import { statisticsSaga } from '$store/statistics/sagas';
import { paidSaga } from '$store/paid/sagas';
import { paySagaRoot } from '$store/pay/sagas';
import { cloudSaga } from '$store/cloud/sagas';
import { storiesSaga } from '$store/stories/saga';
import { streamsSaga } from '$store/streams/sagas';
import { adsSaga } from '$store/ads/sagas';
import { listsSaga } from '$store/lists/sagas';
import { confirmSaga } from '$store/confirm/sagas';
import { appSaga } from '$store/app/sagas';
import { liveSaga } from '$store/live/sagas';
import { reelsSaga } from '$store/reels/sagas';
import { bundlesSaga } from '$store/bundles/sagas';
import { dashboardSaga } from '$store/dashboard/sagas';
import { paymentMethodsSaga } from '$store/paymentMethods/sagas';
import { trialLinksSaga } from '$store/trialLinks/sagas';
import { promoLinksSaga } from '$store/promoLinks/sagas';
import { notesSaga } from '$store/notes/sagas';
import { telegramSaga } from '$store/telegram/saga';
import { offersSaga } from '$store/offers/sagas';
import { mineSaga } from '$store/mine/sagas';
import { addListMemberSaga } from '$store/addListMember/sagas';
import { giftsSaga } from '$store/gifts/sagas';
import { leaderboardSaga } from '$store/leaderboard/sagas';
import { adventCalendarSaga } from '$store/adventCalendar/sagas';

export function* rootSaga() {
  yield all([
    authSaga(),
    profileSaga(),
    postsSaga(),
    attachSaga(),
    feedSaga(),
    searchSaga(),
    followersSaga(),
    groupsSaga(),
    imSaga(),
    realtimeSaga(),
    blacklistSaga(),
    notifySaga(),
    inviteSaga(),
    editGroupSaga(),
    resolverSaga(),
    mainSaga(),
    likesSaga(),
    balanceSaga(),
    agentSaga(),
    monetizationSaga(),
    exploreSaga(),
    subscriptionsSaga(),
    statisticsSaga(),
    paidSaga(),
    paySagaRoot(),
    cloudSaga(),
    storiesSaga(),
    streamsSaga(),
    adsSaga(),
    listsSaga(),
    confirmSaga(),
    appSaga(),
    reelsSaga(),
    liveSaga(),
    bundlesSaga(),
    dashboardSaga(),
    paymentMethodsSaga(),
    trialLinksSaga(),
    promoLinksSaga(),
    notesSaga(),
    telegramSaga(),
    offersSaga(),
    mineSaga(),
    addListMemberSaga(),
    giftsSaga(),
    leaderboardSaga(),
    adventCalendarSaga(),
  ]);
}
